<template>
  <tr>
    <td>
      {{ tableRowNumber(currentPage, perPage, index) }}
    </td>
    <td>
      <div class="artwork artwork--min">
        <div class="artwork-image">
          <img
            :src="artwork.imageThumbUrl"
            alt=""
          />
          <p class="mt-2 artwork-starting-price">{{ I18n.t("price_with_currency", { price: artwork.startingPrice }) }}</p>
        </div>
        <div class="artwork__details">
          <div class="headings--h2 artwork__header mb-0"> {{ artwork.catalogNumber }} </div>
          <div class="headings--h2 artwork__header">
            <ArtistDetails
              v-if="artist"
              :artist="artist"
            />
            <div v-else>
              {{ artwork.name }}
            </div>
          </div>
        </div>
      </div>
    </td>
    <td>
      {{ artwork.reportedToBidArtworksCount }}
    </td>
    <td>
      <UserDetails
        v-for="(reportedToBidArtwork, index) in artwork.reportedToBidArtworks"
        :user="reportedToBidArtwork.user"
        :key="index"
      />
    </td>
  </tr>
</template>

<script>
  import { tableRowNumber } from '@/shared/helpers';
  import ArtistDetails from '@/shared/components/artist_details';
  import { DEFAULT_PER_PAGE } from './../../../consts';
  import UserDetails from './user_details';

  export default {
    name: 'FinishedAuctionsCatalogOrdersRow',
    components: {
      ArtistDetails,
      UserDetails,
    },
    props: {
      meta: {
        required: true,
        type: Object,
      },
      artwork: {
        required: true,
        type: Object,
      },
      artist: {
        required: false,
        type: Object,
      },
      index: {
        required: true,
        type: Number,
      },
    },
    created() {
      this.tableRowNumber = tableRowNumber;
    },
    computed: {
      perPage() {
        return this.meta.per_page || DEFAULT_PER_PAGE;
      },
      currentPage() {
        return this.$route.query.page || 1;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/reported_to_bid_artworks/row.vue?7887faad